export default "__VITE_ASSET__BU_ft5FZ__"